import { useEffect, useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";

const TITLE = "Calculatrice Google AdSense - Estimez vos revenus publicitaires";
const DESCRIPTION =
  "Estimez vos revenus Google AdSense selon vos pages vues, le nombre d'annonces par page, le CTR et le CPC. Outil gratuit pour blogueurs et editeurs web avec conversion par jour, semaine, mois et annee.";
const KEYWORDS =
  "calculatrice adsense, revenus google adsense, estimation revenus site web, ctr adsense, cpc adsense, revenus publicitaires, pages vues";
const OG_URL = "https://do-calculate.com/calculator/fr/google-adsense/";

const conversionMap = {
  day: 1,
  week: 7,
  month: 30.436875,
  year: 365.2425,
};

const inputStyle = {
  width: "200px",
  marginLeft: "10px",
  backgroundColor: "#f9f9f9",
  border: "1px solid rgba(0, 0, 0, 0.23)",
  borderRadius: "4px",
  padding: "8.5px 14px",
  fontSize: "14px",
  outlineColor: "#2e7d32",
};

const selectStyle = {
  ...inputStyle,
  width: "auto",
  padding: "7.5px 10px",
  cursor: "pointer",
};

const labelStyle = {
  display: "block",
  fontSize: "12px",
  color: "#666",
  marginBottom: "4px",
};

const GoogleAdsenseCalculator = () => {
  const [pageViews, setPageViews] = useState("");
  const [pageViewsPeriod, setPageViewsPeriod] = useState("day");
  const [adsPerPage, setAdsPerPage] = useState("");
  const [CTR, setCTR] = useState("");
  const [CPC, setCPC] = useState("");

  const [conversionImpressions, setConversionImpressions] = useState("day");
  const [conversionClicks, setConversionClicks] = useState("day");
  const [conversionRevenue, setConversionRevenue] = useState("day");

  const [adImpressions, setAdImpressions] = useState("");
  const [numberOfClicks, setNumberOfClicks] = useState("");
  const [adsenseRevenue, setAdsenseRevenue] = useState("");

  useEffect(() => {
    const views    = parseFloat(pageViews);
    const ads      = parseFloat(adsPerPage);
    const ctr      = parseFloat(CTR) / 100;
    const cpc      = parseFloat(CPC);
    const inFactor = conversionMap[pageViewsPeriod];

    if (isNaN(views) || views <= 0 || !inFactor) {
      setAdImpressions(""); setNumberOfClicks(""); setAdsenseRevenue(""); return;
    }
    const dailyViews = views / inFactor;
    if (isNaN(ads) || ads <= 0) {
      setAdImpressions(""); setNumberOfClicks(""); setAdsenseRevenue(""); return;
    }
    const dailyImpressions = dailyViews * ads;
    setAdImpressions(Math.round(dailyImpressions * conversionMap[conversionImpressions]));
    if (isNaN(ctr)) { setNumberOfClicks(""); setAdsenseRevenue(""); return; }
    const dailyClicks = dailyImpressions * ctr;
    setNumberOfClicks(Math.round(dailyClicks * conversionMap[conversionClicks]));
    if (isNaN(cpc)) { setAdsenseRevenue(""); return; }
    const dailyRevenue = dailyClicks * cpc;
    setAdsenseRevenue((dailyRevenue * conversionMap[conversionRevenue]).toFixed(2));
  }, [pageViews, pageViewsPeriod, adsPerPage, CTR, CPC, conversionImpressions, conversionClicks, conversionRevenue]);

  const handlePageViewsChange = (e) => { if (/^\d*$/.test(e.target.value)) setPageViews(e.target.value); };
  const handleAdsPerPageChange = (e) => { if (/^\d*$/.test(e.target.value)) setAdsPerPage(e.target.value); };
  const handleCTRChange = (e) => { if (/^\d*\.?\d*$/.test(e.target.value)) setCTR(e.target.value); };
  const handleCPCChange = (e) => { if (/^\d*\.?\d*$/.test(e.target.value)) setCPC(e.target.value); };

  const handleReset = () => {
    setPageViews(""); setPageViewsPeriod("day"); setAdsPerPage(""); setCTR(""); setCPC("");
    setConversionImpressions("day"); setConversionClicks("day"); setConversionRevenue("day");
    setAdImpressions(""); setNumberOfClicks(""); setAdsenseRevenue("");
  };

  const PeriodSelect = ({ value, onChange }) => (
    <select value={value} onChange={onChange} style={selectStyle}>
      <option value="day">Par jour</option>
      <option value="week">Par semaine</option>
      <option value="month">Par mois</option>
      <option value="year">Paran</option>
    </select>
  );

  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row"><div className="col-12 col-md-8"><FirstAds /></div></div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="row">
            <div>
              <h2 style={{ fontSize: "18px" }}>Qu&apos;est-ce que Google AdSense :</h2>
              <p>
                Google AdSense est un programme developpe par Google qui permet aux editeurs de sites web de
                monetiser leur contenu en affichant des publicites ciblees. Les annonceurs encherissent sur
                l&apos;espace publicitaire et Google associe automatiquement les annonces pertinentes au contenu du site.
              </p>
              <p>
                Comment calculer les revenus Google AdSense :<br />
                Impressions = pages vues x annonces par page.<br />
                Clics = Impressions x CTR.<br />
                <strong>Revenus AdSense = pages vues x annonces par page x CTR x CPC</strong>
              </p>
              <hr />
            </div>
          </div>
          <MobileUnderCalAds />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <h3 className="p-3 mb-3 bg-success text-white" style={{ fontSize: "16px", fontWeight: "bold", borderRadius: "4px" }}>
                Calcul des revenus Google AdSense
              </h3>

              <div className="mb-3 d-flex" style={{ alignItems: "flex-end" }}>
                <div>
                  <label style={labelStyle}>Pages vues</label>
                  <input style={inputStyle} type="text" inputMode="numeric" value={pageViews} onChange={handlePageViewsChange} placeholder="Ex: 100000" />
                </div>
                <PeriodSelect value={pageViewsPeriod} onChange={(e) => setPageViewsPeriod(e.target.value)} />
              </div>

              <div className="mb-3 d-flex" style={{ alignItems: "flex-end" }}>
                <div>
                  <label style={labelStyle}>Annonces par page</label>
                  <input style={inputStyle} type="text" inputMode="numeric" value={adsPerPage} onChange={handleAdsPerPageChange} placeholder="Ex: 3" />
                </div>
                <div style={{ padding: "8.5px 12px", fontSize: "14px", color: "#666" }}>Par page</div>
              </div>

              <div className="mb-3 d-flex" style={{ alignItems: "flex-end" }}>
                <div>
                  <label style={labelStyle}>Impressions publicitaires</label>
                  <input style={inputStyle} type="text" value={adImpressions} readOnly placeholder="—" />
                </div>
                <PeriodSelect value={conversionImpressions} onChange={(e) => setConversionImpressions(e.target.value)} />
              </div>

              <hr />

              <div className="mb-3 d-flex" style={{ alignItems: "flex-end" }}>
                <div>
                  <label style={labelStyle}>Taux de clic (CTR)</label>
                  <input style={inputStyle} type="text" inputMode="decimal" value={CTR} onChange={handleCTRChange} placeholder="Ex: 2.5" />
                </div>
                <div style={{ fontSize: "20px", paddingBottom: "5px" }}>%</div>
              </div>

              <div className="mb-3 d-flex" style={{ alignItems: "flex-end" }}>
                <div>
                  <label style={labelStyle}>Nombre de clics</label>
                  <input style={inputStyle} type="text" value={numberOfClicks} readOnly placeholder="—" />
                </div>
                <PeriodSelect value={conversionClicks} onChange={(e) => setConversionClicks(e.target.value)} />
              </div>

              <hr />

              <div className="mb-3 d-flex" style={{ alignItems: "flex-end" }}>
                <div>
                  <label style={labelStyle}>Cout par clic (CPC)</label>
                  <input style={inputStyle} type="text" inputMode="decimal" value={CPC} onChange={handleCPCChange} placeholder="Ex: 0.50" />
                </div>
                <div style={{ fontSize: "20px", paddingBottom: "5px" }}>$</div>
              </div>

              <div className="mb-3 d-flex" style={{ alignItems: "flex-end" }}>
                <div>
                  <label style={labelStyle}>Revenus estimes</label>
                  <input style={{ ...inputStyle, backgroundColor: "#e8f5e9", fontWeight: "bold" }} type="text" value={adsenseRevenue} readOnly placeholder="—" />
                </div>
                <PeriodSelect value={conversionRevenue} onChange={(e) => setConversionRevenue(e.target.value)} />
                <div style={{ fontSize: "20px", paddingBottom: "5px", marginLeft: "4px" }}>$</div>
              </div>

              <div className="text-center mt-3 mb-3">
                <button onClick={handleReset} className="btn btn-secondary">Reinitialiser</button>
              </div>
            </div>
          </div>
          <hr />
          <div className="row"><RelatedLinks /><hr style={{ width: "100%" }} /></div>
        </div>
        <div className="col">
          <SecondAds /><br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>

      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><strong>Comment utiliser cette calculatrice AdSense ?</strong></div>
              <div className="info-section-body">
                <p>Cette calculatrice vous aide a estimer vos revenus AdSense en quelques etapes simples :</p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>Entrez le nombre de pages vues de votre site (par jour, semaine, mois ou an)</li>
                  <li>Entrez le nombre moyen d&apos;annonces affichees par page (generalement 2 a 4)</li>
                  <li>Entrez le taux de clic (CTR) — la moyenne se situe entre 1 % et 5 %</li>
                  <li>Entrez le cout par clic moyen (CPC) en dollars — varie selon la thematique et le pays</li>
                  <li>Les resultats s&apos;actualisent automatiquement avec choix de periode d&apos;affichage</li>
                </ol>
                <div className="alert alert-info mt-3">
                  <strong>Note :</strong> Cette calculatrice fournit une estimation indicative. Les revenus reels dependent de la thematique, du pays des visiteurs, de la saisonnalite et de la qualite des emplacements publicitaires.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><strong>Comment augmenter vos revenus AdSense ?</strong></div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px" }}>1. Choisir une thematique avec un CPC eleve :</h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Thematiques les plus rentables :</strong> assurance, droit, finance, sante, immobilier</li>
                  <li><strong>Thematiques moyennes :</strong> technologie, education, voyage, e-commerce</li>
                  <li><strong>Thematiques faibles :</strong> divertissement, actualites generales</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>2. Optimiser le placement des annonces :</h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Annonces au-dessus de la ligne de flottaison :</strong> la partie visible sans defilement genere des taux de clic superieurs</li>
                  <li>Integrer les annonces dans le contenu ameliore le CTR naturellement</li>
                  <li>Eviter les pages surchargees d&apos;annonces qui degradent l&apos;experience utilisateur</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><strong>Explication des termes : CTR, CPC, RPM et CPM</strong></div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>Pour utiliser correctement la calculatrice AdSense et comprendre vos rapports, voici les termes cles :</p>
                <table className="table bmi-table" style={{ marginTop: "1rem" }}>
                  <thead>
                    <tr>
                      <th className="bmi-header" style={{ textAlign: "center" }}>Terme</th>
                      <th className="bmi-header" style={{ textAlign: "center" }}>Signification</th>
                      <th className="bmi-header" style={{ textAlign: "center" }}>Moyenne courante</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ textAlign: "center" }}><strong>CTR</strong> — Taux de clic</td>
                      <td style={{ textAlign: "center" }}>Clics ÷ Impressions × 100</td>
                      <td style={{ textAlign: "center" }}>1 % — 3 %</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}><strong>CPC</strong> — Cout par clic</td>
                      <td style={{ textAlign: "center" }}>Gain par clic sur une annonce</td>
                      <td style={{ textAlign: "center" }}>0,10 $ — 2,00 $</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}><strong>RPM</strong> — Revenu pour 1 000 impressions</td>
                      <td style={{ textAlign: "center" }}>Revenus ÷ Impressions × 1 000</td>
                      <td style={{ textAlign: "center" }}>1 $ — 10 $</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}><strong>CPM</strong> — Cout pour 1 000 impressions</td>
                      <td style={{ textAlign: "center" }}>Montant paye par l&apos;annonceur pour 1 000 affichages</td>
                      <td style={{ textAlign: "center" }}>0,50 $ — 5 $</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}><strong>Page RPM</strong></td>
                      <td style={{ textAlign: "center" }}>Revenus ÷ Pages vues × 1 000</td>
                      <td style={{ textAlign: "center" }}>1 $ — 15 $</td>
                    </tr>
                  </tbody>
                </table>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>Quel CTR est considere comme bon sur AdSense ?</h3>
                <p style={{ lineHeight: "1.8" }}>Un CTR entre <strong>1 % et 3 %</strong> est la norme pour la plupart des sites. Tout CTR superieur a 3 % est excellent, mais attention : un CTR anormalement eleve (superieur a 10 %) peut alerter Google sur des clics invalides.</p>
                <div className="alert alert-success mt-3" style={{ lineHeight: "1.8" }}>
                  <strong>Conseil :</strong> Vous pouvez utiliser cette calculatrice a l&apos;envers — entrez le revenu cible et testez differentes valeurs de CTR et CPC pour savoir ce que vous devez atteindre.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><strong>Exemples pratiques de calcul de revenus AdSense</strong></div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>Exemple 1 : Blog generaliste moyen</h3>
                <p style={{ lineHeight: "1.8" }}><strong>Donnees :</strong> 5 000 pages vues/jour, 3 annonces/page, CTR = 2 %, CPC = 0,30 $</p>
                <div className="alert alert-info" style={{ fontSize: "14px", lineHeight: "1.8" }}>
                  <strong>Calcul :</strong><br />
                  Impressions = 5 000 × 3 = 15 000 impressions/jour<br />
                  Clics = 15 000 × 2 % = 300 clics/jour<br />
                  Revenu journalier = 300 × 0,30 $ = <strong>90 $/jour</strong><br />
                  Revenu mensuel ≈ <strong>2 700 $/mois</strong>
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>Exemple 2 : Site tech specialise</h3>
                <p style={{ lineHeight: "1.8" }}><strong>Donnees :</strong> 2 000 pages vues/jour, 3 annonces, CTR = 1,5 %, CPC = 1,50 $</p>
                <div className="alert alert-info" style={{ fontSize: "14px", lineHeight: "1.8" }}>
                  <strong>Calcul :</strong><br />
                  Impressions = 2 000 × 3 = 6 000/jour<br />
                  Clics = 6 000 × 1,5 % = 90 clics/jour<br />
                  Revenu journalier = 90 × 1,50 $ = <strong>135 $/jour</strong><br />
                  Revenu mensuel ≈ <strong>4 050 $/mois</strong>
                </div>
                <p style={{ lineHeight: "1.8" }}>Remarquez que le site tech genere plus de revenus malgre moins de visites — grace a un CPC plus eleve dans la thematique technologie.</p>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>Exemple 3 : Grand site d&apos;actualites</h3>
                <p style={{ lineHeight: "1.8" }}><strong>Donnees :</strong> 100 000 pages vues/jour, 3 annonces, CTR = 1 %, CPC = 0,15 $</p>
                <div className="alert alert-info" style={{ fontSize: "14px", lineHeight: "1.8" }}>
                  <strong>Calcul :</strong><br />
                  Impressions = 100 000 × 3 = 300 000/jour<br />
                  Clics = 300 000 × 1 % = 3 000 clics/jour<br />
                  Revenu journalier = 3 000 × 0,15 $ = <strong>450 $/jour</strong><br />
                  Revenu mensuel ≈ <strong>13 500 $/mois</strong>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><strong>Questions frequentes sur Google AdSense</strong></div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "8px" }}>Combien paie AdSense pour 1 000 vues ?</h3>
                <p style={{ lineHeight: "1.8" }}>Le RPM moyen (revenu pour 1 000 pages vues) se situe entre <strong>1 $ et 10 $</strong> dans la plupart des thematiques, et peut depasser 50 $ dans des domaines comme l&apos;assurance ou le droit. Tout depend du pays des visiteurs, de la thematique et de la qualite du contenu.</p>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "8px" }}>Y a-t-il un nombre minimum de visites pour s&apos;inscrire a AdSense ?</h3>
                <p style={{ lineHeight: "1.8" }}>Il n&apos;existe pas de seuil officiel de trafic, mais Google recommande un site avec du <strong>contenu original et suffisant</strong> (au moins 20-30 articles) avant de postuler. La qualite du contenu et le respect des politiques Google priment sur le volume de trafic.</p>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "8px" }}>AdSense est-il compatible avec les sites en francais ?</h3>
                <p style={{ lineHeight: "1.8" }}>Oui, <strong>Google AdSense supporte pleinement les sites en francais</strong>. La France, la Belgique, le Canada francophone et la Suisse font partie des marches francophones les plus actifs avec des CPC generalement bons, en particulier dans les secteurs finance, sante et immobilier.</p>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "8px" }}>Quand les revenus AdSense sont-ils vires sur le compte bancaire ?</h3>
                <p style={{ lineHeight: "1.8" }}>Google AdSense effectue des paiements mensuels des que le solde depasse le seuil de <strong>70 €</strong> (ou 100 $ selon la devise). Les revenus sont confirmes en fin de mois et vires entre le 21 et le 26 du mois suivant.</p>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "8px" }}>Quelle est la difference entre AdSense et AdMob ?</h3>
                <p style={{ lineHeight: "1.8" }}><strong>Google AdSense</strong> est destine aux sites web (ordinateur et mobile), tandis que <strong>Google AdMob</strong> est concu pour les applications mobiles (iOS et Android). Les deux programmes utilisent le meme reseau d&apos;annonceurs Google mais s&apos;adressent a des supports differents.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row"><div className="col-12 col-md-8"><br /><SecondAds /></div></div>
    </div>
  );
};

export default GoogleAdsenseCalculator;
